import React, { createContext, useContext } from "react";

// Per-page signed chat config token (base64url payload + "." + hex sig), or null.
// Populated at build into pageContext.chatCfg and provided per page via
// wrapPageElement (gatsby-ssr.js + gatsby-browser.js). SPA-safe: Gatsby updates
// pageContext on client-side navigation, so the provider value tracks the page.
const ChatCfgContext = createContext<string | null>(null);

export function ChatCfgProvider({
  value,
  children,
}: {
  value: string | null;
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <ChatCfgContext.Provider value={value}>{children}</ChatCfgContext.Provider>
  );
}

export function useChatCfg(): string | null {
  return useContext(ChatCfgContext);
}
